// extracted by mini-css-extract-plugin
export default {"waves":"Tzz_FbQs"};